<template>
  <!-- //TODO: currency format -->
  <div class="calculation-box">
    <div class="calculation-box__title">價格計算</div>
    <div class="calculation-box__list price-calculate">
      <CalculateBoxItem :title="'購買金額'" :amount="total"></CalculateBoxItem>

      <!-- 各種折扣 -->
      <CalculateBoxItem
        v-for="(discount, index) in discountList"
        :key="`discount-${index}`"
        :title="nameMap[index]"
        :amount="discount"
        amountClass="dis"
        :showDollarSymbol="index !== 'giveaway_discount_amount'"
      ></CalculateBoxItem>
      <!-- 各種折扣end -->

      <CalculateBoxItem
        title="小計"
        class="subtotal"
        :amount="subtotalBeforeOrderDiscount"
      ></CalculateBoxItem>

      <!-- 訂單折扣 - 滿額加價購 -->
      <CalculateBoxItem
        v-if="
          discount && discount.type === 11 && order.discount_event_price > 0
        "
        :title="discount.title"
        :amount="order.discount_event_price"
      />

      <!-- 訂單折扣 - 滿額折扣 -->
      <CalculateBoxItem
        v-if="discount && (discount.type === 8 || discount.type === 9)"
        :title="discount.title"
        amountClass="dis"
        :amount="discount.price"
      />
      <!-- 訂單折扣 end -->

      <CalculateBoxItem
        title="折扣後小計"
        class="subtotal"
        v-if="subtotal !== subtotalBeforeOrderDiscount"
        :amount="subtotal"
      ></CalculateBoxItem>

      <!-- 抵用券&總價折抵 -->
      <CalculateBoxItem
        v-for="(subtotalDiscount, index) in subtotalDiscountList"
        :key="`subtotal-discount-${index}`"
        :title="nameMap[index]"
        amountClass="dis"
        :amount="subtotalDiscount"
      ></CalculateBoxItem>
      <!-- 抵用券&總價折抵 end-->

      <CalculateBoxItem
        class="total"
        :title="'應收金額'"
        amountClass="final-price"
        :amount="receivableAmount"
      ></CalculateBoxItem>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { pick, pickBy, get, forOwn } from 'lodash';
import CalculateBoxItem from '@/components/CheckoutDetail/CalculateBoxItem';

export default {
  components: {
    CalculateBoxItem
  },
  props: {
    coupons: {
      required: true,
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      nameMap: {
        //上層
        level_discount_amount: '會員方案優惠',
        giveaway_discount_amount: '贈品',
        combination_discount_amount: '商品促銷折抵',
        product_discount_price: '商品折價',
        product_discount_percent: '商品折扣',
        program_discount_price: '方案折價',
        program_discount_percent: '方案折扣',
        course_discount: '課程9折券折扣',
        //小計之後下層
        subtotal_discount_amount: '小計再折抵',
        coupon_type_2: '商品券100元',
        coupon_type_3: '課程券100元',
        coupon_type_4: '課程/商品抵用券100元'
      }
    };
  },
  computed: {
    ...mapState('order', ['discount', 'subtotalBeforeOrderDiscount']),
    ...mapGetters('order', ['order']),
    discountList() {
      let list = pick(this.order, [
        'level_discount_amount',
        'giveaway_discount_amount',
        'combination_discount_amount',
        'product_discount_price',
        'product_discount_percent',
        'program_discount_price',
        'program_discount_percent',
        'course_discount'
      ]);

      return this.filter(list);
    },
    usingCoupons() {
      let coupons = {};

      forOwn(
        pickBy(this.coupons, coupon => {
          return coupon.qty > 0 && coupon.type != 1;
        }),
        coupon => {
          coupons['coupon_type_' + coupon.type] = 100 * coupon.qty;
        }
      );

      return coupons;
    },
    subtotalDiscountList() {
      let list = pick(this.order, ['subtotal_discount_amount']);

      list = this.filter(list);

      Object.assign(list, this.usingCoupons);

      return list;
    },
    total() {
      return get(this.order, 'total');
    },
    subtotal() {
      return get(this.order, 'subtotal');
    },
    receivableAmount() {
      return get(this.order, 'receivable_amount');
    }
  },
  methods: {
    filter(list) {
      return pickBy(list, value => {
        return value > 0;
      });
    }
  }
};
</script>
